var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 3.2373V17.0123L3.3125 25.1873C2.25 23.9248 2.1875 22.0123 3.375 19.8748L7.275 12.8623L10.95 6.2498C12.0625 4.2498 13.525 3.2373 15 3.2373Z",
    fill: "var(--fill-0, #0C0C0C)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.6,
    d: "M26.6874 25.1873C25.8749 26.1748 24.4624 26.7623 22.5749 26.7623H7.42488C5.53738 26.7623 4.12488 26.1748 3.31238 25.1873L14.9999 17.0123L26.6874 25.1873Z",
    fill: "var(--fill-0, #0C0C0C)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M26.6875 25.1873L15 17.0123V3.2373C16.475 3.2373 17.9375 4.2498 19.05 6.2498L22.725 12.8623L26.625 19.8748C27.8125 22.0123 27.75 23.9248 26.6875 25.1873Z",
    fill: "var(--fill-0, #0C0C0C)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangle);
export default __webpack_public_path__ + "static/media/icon-triangle.c9f9c3b6354eabfba79b5a3810d215c5.svg";
export { ForwardRef as ReactComponent };